<template>
  <div>
    <base-header class="pb-6" type="pink">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Perfil de Usuaria</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
      </b-row>
    </base-header>

    <b-container v-if="user" fluid class="mt--6">

      <b-row>
        <!-- User Static Info -->
        <b-col>
          <!-- User Card -->
          <user-card v-if="user" :user="user" @updatePicture="updatePicture"></user-card>

          <!-- Payments Table -->
          <div v-if="payments">
            <card class="no-border-card" body-classes="px-0 pb-1">
              
              <template slot="header">
                <div class="d-flex justify-content-between align-content-center">
                  <h3>Historial de Pagos</h3>
                  <b-link v-if="user.cHasVideoAccess" class="btn btn-warning btn-sm py-2" :to="{ name: 'Checkout' }">
                    <span>Adelantar un pago</span>
                  </b-link>
                </div>
              </template>

              <!-- Table -->
              <b-table responsive outlined hover head-variant="light" :items="payments" :fields="ptFields" :per-page="ptPerPage" :current-page="ptCurrentPage" class="user-table">
        
              </b-table>

              <!-- Table Footer -->
              <div slot="footer">
                <b-row>
                  <b-col>
                    <b-pagination pills size="sm" align="center" v-model="ptCurrentPage" :total-rows="ptRows" :per-page="ptPerPage"></b-pagination>
                  </b-col>
                </b-row>
              </div>

            </card>
          </div>
        </b-col>

        <!-- Info Cards -->
        <b-col xl="8" class="order-xl-1">
          <b-row>
            <b-col lg="6">

              <card gradient="info" v-if="user.userType" class="border-0">
                <div class="d-flex align-items-center">
                  <div class="mr-auto">
                    <h5 class="card-title text-white text-uppercase text-muted mb-0">Estatus de cuenta</h5>
                    <span v-if="user.cHasVideoAccess" class="h2 text-white font-weight-bold mb-0">Activa</span>
                    <span v-if="!user.cHasVideoAccess" class="h2 text-white font-weight-bold mb-0">Limitada</span>
                  </div>
                  <div v-if="!user.cHasVideoAccess" class="mr-2">
                    <b-link class="btn btn-warning btn-sm" :to="{ name: 'Checkout' }">
                      <span class="btn-inner--text">Ir al pago</span>
                    </b-link> 
                  </div>
                  <div>
                    <div v-if="user.cHasVideoAccess" class="icon icon-shape bg-success text-dark rounded-circle shadow">
                      <i class="fas fa-check text-white"></i>
                    </div>
                    <div v-if="!user.cHasVideoAccess" class="icon icon-shape bg-yellow text-dark rounded-circle shadow">
                      <i class="fas fa-pause text-white"></i>
                    </div>
                  </div>
                </div>
              </card>

            </b-col>
            <b-col lg="6" >

              <card gradient="danger" class="border-0">
                <div class="d-flex">
                  <div>
                    <h5 class="card-title text-uppercase text-muted mb-0 text-white">Acceso Hasta:</h5>
                    <span v-if="user.userType==='user' && user.accessUntil" class="h2 font-weight-bold mb-0 text-white">{{ user.accessUntil }}</span>
                    <span v-else class="h2 font-weight-bold mb-0 text-white">N/A</span>                    
                  </div>
                  <div class="ml-auto">
                    <div class="icon icon-shape bg-white text-dark rounded-circle shadow">
                      <i class="fas fa-key"></i>
                    </div>
                  </div>
                </div>
                <!-- <p class="mt-1 mb-0 text-sm">
                  <span class="text-white mr-2"><i class="fa fa-calendar-day"></i> 14</span>
                  <span class="text-nowrap text-light">Días restantes</span>
                </p> -->
              </card>

            </b-col>
          </b-row>

          <!-- Perfil de Usuaria -->
          <b-card no-body class="mb-4">

            <b-card-header class="profile-form-header">
              <h3 class="mb-0">Perfil de Usuaria</h3>
              <b-button size="sm" variant="danger" @click="showDeleteModal=!showDeleteModal">Eliminar cuenta</b-button>
            </b-card-header>

            <b-card-body>
              <b-form @submit.prevent="onSubmit">

                <h6 class="heading-small text-muted mb-4">Información de Contacto</h6>
                <!-- Row 1 -->
                <b-row>
                  <!-- Name -->
                  <b-col>
                    <base-input label="Nombre" type="text" v-model="user.name"></base-input>
                  </b-col>

                </b-row>

                <!-- Row 2 -->
                <b-row>
                  <!-- Email -->
                  <b-col>
                    <base-input label="Email" type="email" v-model="user.email" disabled></base-input>
                  </b-col>

                  <!-- Phone Number -->
                  <b-col>
                    <base-input label="Teléfono" type="tel" v-model="user.phone"></base-input>
                  </b-col>
                </b-row>

                <!-- Login Type -->
                <b-row>
                  <b-col>
                    <base-input label="Login" type="text" v-model="user.loginType" disabled></base-input>
                  </b-col>
                </b-row>

                <hr class="my-4">

                <h6 class="heading-small text-muted mb-4">Información de Acceso</h6>

                <!-- User Type -->
                <b-row>
                  <b-col>
                    <base-input label="Tipo de Usuaria">
                      <el-select v-model="user.userType" disabled filterable placeholder="Tipo de Usuaria">
                        <el-option v-for="option in userTypes" :key="option.label" :label="option.label" :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                </b-row>

                <!-- Paid Info -->
                <div v-if="user.userType === 'user'">
                  <!-- Paid Options-->
                  <b-row align-v="center">
                    <b-col cols="6">
                      <base-input label="Pagado">
                        <el-select v-model="user.hasPaidAccess" disabled>
                          <el-option v-for="option in paidOptions" :key="option.label" :label="option.label" :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>

                    <b-col cols="6">
                      <base-input label="Acceso Manual">
                        <el-select v-model="user.hasManualAccess" disabled>
                          <el-option v-for="option in paidOptions" :key="option.label" :label="option.label" :value="option.value">
                          </el-option>
                        </el-select>
                      </base-input>
                    </b-col>

                  </b-row>

                  <!-- Expiration Date -->
                  <b-row>
                    <b-col>
                      <base-input label="Fecha de expiración">
                        <b-form-datepicker id="accessUntil" v-model="user.accessUntil" disabled></b-form-datepicker>
                      </base-input>
                    </b-col>
                  </b-row>

                </div>
                
                <!-- Submit -->
                <b-button type="submit" variant="primary">Actualizar</b-button>
              </b-form>
            </b-card-body>

          </b-card>

        </b-col>
      </b-row>

    </b-container>

    <!-- Delete User Modal -->
      <modal :show.sync="showDeleteModal"
              modal-classes="modal-danger"
              modal-content-classes="bg-gradient-danger">
        <h6 slot="header" class="modal-title">¡Alerta! ¿Estás segura?</h6>

        <div class="py-3 text-center">
          <i class="ni ni-bell-55 ni-3x"></i>
          <h4 class="heading mt-4">Esta acción no es reversible.</h4>
          <p>
            Una vez que aceptes esta operación, tus datos de sesión, así como tu historial de pagos, será borrado de nuestras bases de datos.
          </p>
        </div>


        <template slot="footer">
          <base-button type="white" @click="deleteAccount">Sí, borrar mi cuenta</base-button>
          <base-button type="white" class="ml-auto" @click="showDeleteModal = false">Cerrar</base-button>
        </template>

      </modal>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import UserCard from './UserProfile/UserCard'
import { Select, Option } from 'element-ui'
import { Modal } from '@/components';
import db from '@/firebase/init'
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/functions'
import { mainStorage } from '@/store/main.js'

export default {
  components: {
    RouteBreadCrumb,
    UserCard,
    [Select.name]: Select,
    [Option.name]: Option,
    Modal
  }, 
  data() {
    return {
      user: mainStorage.state.user,
      payments: null,
      userTypes: [
        {
          label: 'Usuaria',
          value: 'user'
        }, 
        {
          label: 'Coach',
          value: 'coach'
        },
        {
          label: 'Admin',
          value: 'admin'
        }
      ],
      paidOptions: [
        { label: "Sí", value: true},
        { label: "No", value: false}
      ],
      uri: '',
      disableInputs: false,
      enableManualAccess: false,
      ptPerPage: 3,
      ptCurrentPage: 1,
      ptFields: [
        { key: 'paymentID', label: 'ID' },
        { key: 'paymentDate', label: 'Fecha' },
        { key: 'paymentAmount', label: 'Monto'}
      ],
      showDeleteModal: false
    }
  },
  methods: {
    onSubmit() {
      this.modifyFirestoreUser()
    },
    deleteAccount() {
      let user = firebase.auth().currentUser
      firebase.auth().signOut()
        .then(() => {
          const deleteAccount = firebase.functions().httpsCallable('deleteUserFromFirebase')
          deleteAccount({ uid: user.uid })
        })
        .then(() => {
          this.$router.push({ name: 'Deleted' })
        })
        .catch((err) => {
          console.log(err.message)
          this.$router.push({ name: 'Error' })
        })
    },
    fetchFirestorePayments(uid) {
      db.collection('payments').doc(uid).get()
        .then(doc => {
          this.payments = doc.data().payments
        })
        .catch(err => {
          console.log(err.message)
        })
    },
    modifyFirestoreUser() {
      db.collection('users').doc(this.user.id).update({
        name: this.user.name,
        phone: this.user.phone,
        photoURL: this.user.photoURL
      })
      .then(() => {
        // this.$router.push({ name: 'Home' })
      })
      .catch(err => {
        console.log(err.message)
      })
    },
    updatePicture(photoURL) {
      this.user.photoURL = photoURL
      this.modifyFirestoreUser()
    }
  },
  computed: {
    telState() {
      if (this.user.phone.length > 0) {
        return this.user.phone.length > 9 ? true : false
      }
      else {
        return null;
      }
    },
    ptRows() {
      return this.payments.length
    },
    showUserType() {
      return this.user.userType
    }
  },
  mounted() {
    let user = firebase.auth().currentUser
    if (user) {
      this.fetchFirestorePayments(user.uid)
    } else {
      this.$router.push({ name: 'Home' })
    }
  }
}
</script>

<style>
.profile-form-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>